<style scoped lang="scss">
</style>
<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/setting/shift/page" getKey="rows"
			:columns="columns">
			<template #top>

			</template>
			<template #conditions>
				<el-form size="mini" :inline="true" class="demo-form-inline">
					<el-form-item :label="$t('banzhibianma')" class="noborder">
						<el-input disabled v-model="$attrs.shift.code">
						</el-input>
					</el-form-item>
					<el-form-item :label="$t('banzhimingcheng')" class="noborder">
						<el-input disabled v-model="$attrs.shift.name">
						</el-input>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" v-if="utils.checkPower('web_base_shift_item_create')" icon="yicon yicon-add_fill" @click="yt.showEditDialog('xinzeng',null,'w1')">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" v-if="utils.checkPower('web_base_shift_item_update')" @click="yt.showEditDialog('bianji', scope.row);calculationTimeLength(scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('web_base_shift_item_delete')" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/setting/shift/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
			<template #shichang="scope">
				{{(scope.row.timeLength/60/60).toFixed(1)}}
			</template>
		</yi_curd_table>
		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('bancibianma')" required="required">
						<el-input v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('bancimingcheng')" required="required">
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('kaishishijian')" required>
						<el-time-picker v-model="yt.editObj.startTime" :placeholder="$t('xuanzeshijian')"
							format='HH:mm:ss' value-format="HH:mm:ss">
						</el-time-picker>
					</el-form-item>
					<el-form-item :label="$t('jieshushijian')" required>
						<el-time-picker v-model="yt.editObj.endTime" :placeholder="$t('xuanzeshijian')"
							format='HH:mm:ss' value-format="HH:mm:ss">
						</el-time-picker>
					</el-form-item>
					<el-form-item :label="$t('shifoukuari')" required="required">
						<el-select filterable :clearable="true" v-model="yt.editObj.isCross">
							<el-option value="true" :label="$t('shi')"></el-option>
							<el-option value="false" :label="$t('fou')"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('shichang')" required="required">
						<el-input v-model="yt.editObj.timeLength" disabled></el-input>
					</el-form-item>
					<el-form-item :label="$t('shunxu')" required="required">
						<el-input v-model="yt.editObj.priority"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/setting/shift/create',beforeAdd)" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('bancibianma')" class="noborder" required="required">
						<el-input disabled v-model="yt.editObj.code">
						</el-input>
					</el-form-item>
					<el-form-item :label="$t('bancimingcheng')" required="required">
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('kaishishijian')" required>
						<el-time-picker v-model="yt.editObj.startTime" :placeholder="$t('xuanzeshijian')"
							format='HH:mm:ss' value-format="HH:mm:ss">
						</el-time-picker>
					</el-form-item>
					<el-form-item :label="$t('jieshushijian')" required>
						<el-time-picker v-model="yt.editObj.endTime" :placeholder="$t('xuanzeshijian')"
							format='HH:mm:ss' value-format="HH:mm:ss">
						</el-time-picker>
					</el-form-item>
					<el-form-item :label="$t('shifoukuari')" required="required">
						<el-select filterable :clearable="true" v-model="yt.editObj.isCross">
							<el-option :label="$t('shi')" :value="true"></el-option>
							<el-option :label="$t('fou')" :value="false"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('shichang')" required="required">
						<el-input v-model="yt.editObj.timeLength" disabled></el-input>
					</el-form-item>
					<el-form-item :label="$t('shunxu')" required="required">
						<el-input v-model="yt.editObj.priority"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/setting/shift/update',beforeAdd)" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script type="text/javascript">
	// import curd_data from '@/common/curd/curd_data';
	export default {
		name: 'web_base_shift_shift_setting',
		data() {
			return {
				columns: [{
					label: 'bancibianma',
					prop: 'code',
					width: 130,
				}, {
					label: 'bancimingcheng',
					prop: 'name',
					width: 130,
				}, {
					label: 'kaishishijian',
					prop: 'startTime',
				}, {
					label: 'jieshushijian',
					prop: 'endTime',
				}, {
					label: 'shifoukuari',
					prop: 'isCross',
					type: 'bool',
					iln18: ['shi', 'fou'],
				}, {
					label: 'shichang',
					type: 'slot',
				}, {
					label: 'shunxu',
					prop: 'priority',
				}, {
					label: 'chuangjianshijian',
					prop: 'createTime',
					type: 'time',
				}, {
					label: 'xiugaishijian',
					prop: 'updateTime',
					type: 'time',
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 150,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				// table列表接口请求参数
				this.yt.conditions = {
					typeId: this.$attrs.shift.id,
					pageSize: 10
				}
				this.yt.get(1, this.beforeGet);
			}, 300)
		},
		methods: {
			beforeGet(params) {
				params['orderBy'] = 'id,priority'
				return params
			},
			beforeAdd(params, url) {
				params.typeId = this.$attrs.shift.id;
				params.timeLength = params.timeLength * 60 * 60;
				return params
			},
			calculationTimeLength(obj){
				this.yt.editObj.timeLength = (obj.timeLength/60/60).toFixed(1)
			}
			


		},
		watch: {
			"yt.editObj": {
				handler(n, o) {
					if (n.startTime && o.endTime) {
						var start = n.startTime.split(':');
						var end = o.endTime.split(':');
						var startHour = start[0];
						var startMinutes = start[1];
						var startSeconds = start[2];

						var endHour = end[0];
						var endMinutes = end[1];
						var endSeconds = end[2];
						var startDate = Number(startHour * 3600) + Number(startMinutes * 60) + Number(startSeconds)
						var endDate = Number(endHour * 3600) + Number(endMinutes * 60) + Number(endSeconds);
						if (startDate >= endDate) {
							endDate = Number(endHour * 3600 + 86400) + Number(endMinutes * 60) + Number(endSeconds)
						}
						var timeLength = (endDate - startDate) / 60 / 60;
						this.yt.editObj.timeLength = timeLength.toFixed(1);
					}
				},
				immediate: false,
				deep: true
			},

		},


	};
</script>
